import moment from 'moment';

interface BaseReportOption {
    id: ReportMenuOption;
    label: string;
}

export interface MainReportOption extends BaseReportOption {
    subItems: Record<string, SubReportOption>;
}

export interface SubReportOption extends BaseReportOption {
    type: ReportType;
    isRecurring: boolean;
}

export enum ReportMenuOption {
    RiskReport = 'RiskReport',
    CyberInsurance = 'CyberInsurance',
    SingleRiskReport = 'SingleRiskReport',
    RecurringRiskReports = 'RecurringRiskReports',
    SingleCyberInsurance = 'SingleCyberInsurance'
}

export enum ReportType {
    RiskReport = 'RiskReport',
    CyberInsurance = 'CyberInsurance'
}

export interface CustomControl {
    name: string;
    policies: string[];
    selectedPolicies: string[];
}

export interface CyberInsuranceMetadata {
    emailPolicies: { selected: boolean; policies: string[]; selectedPolicies: string[] };
    vpnPolicies: { selected: boolean; policies: string[]; selectedPolicies: string[] };
    oldPassword: { selected: boolean; value: number };
    customControls: CustomControl[];
    useCustomerIcon: boolean;
}

export interface RiskReportMetadata {
    startDate: moment.Moment;
    endDate: moment.Moment;
    modules: string[];
}

interface CyberInsuranceConfig {
    type: ReportType.CyberInsurance;
    metadata: CyberInsuranceMetadata;
}

interface RiskReportConfig {
    type: ReportType.RiskReport;
    metadata: RiskReportMetadata;
}

export type ReportConfig = CyberInsuranceConfig | RiskReportConfig;

interface RecurringRiskReportConfig {
    type: ReportType.RiskReport;
    metadata: {
        modules: string[];
        environment: 'cloud' | 'onPrem';
    };
}

interface RecurringReportBaseConfig {
    id?: number;
    assessment_period: number;
    frequency: number;
    hour: number | null;
    timezone: string | null;
    day_of_week: number | null;
    day_of_month: number | null;
    recipients: string[];
    is_active: boolean;
}

export type RecurringReportConfig = RecurringReportBaseConfig & RecurringRiskReportConfig;
